module.exports = __webpack_public_path__ + "static/media/baseMeme14.d9320cbd.jpg";